<template>
  <div v-if="!loading" class="min-h-screen bg-white pb-16">
    <PrintableOffer :offer="offerData" :account-relation="accountRelation" />
  </div>
</template>

<script>
import PrintableOffer from 'Components/Offers/PrintableOffer.vue';

export default {
  components: {
    PrintableOffer,
  },
  props: {
    offerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      offerData: {},
    };
  },
  computed: {
    offer() {
      return this.$store.state.entities.offers.byId[this.offerId];
    },
    account() {
      return this.$store.state.entities.accounts.byId[this.offer.accountUuid];
    },
    accountRelation() {
      return (
        this.$store.state.entities.accountRelations.byId[this.offer.accountRelationUuid] || null
      );
    },
  },
  created() {
    this.fetchOffer();
  },
  methods: {
    async fetchOffer() {
      try {
        this.setLoading(true);
        await this.$store.dispatch({
          type: 'ui/offers/read',
          offerUuid: this.offerId,
          params: {
            include: [
              'account.paymentAccounts',
              'account.logo',
              'contact',
              'accountRelation.relatedAccount.logo',
              'accountRelation.relatedAccount.registrations',
              'lines.product',
            ].join(','),
          },
        });
        this.setOfferData();
      } catch (error) {
        //
      } finally {
        this.setLoading(false);
      }
    },
    setLoading(value) {
      this.loading = value;
    },
    setOfferData() {
      this.offerData = {
        number: '',
        issueDate: '',
        issuerName: '',
        issuerAddress: '',
        issuerVatNumber: '',
        issuerVatOffice: '',
        recipientName: '',
        recipientAddress: '',
        recipientVatNumber: '',
        recipientVatOffice: '',
        contactId: null,
        accountRelationUuid: null,
        ...(this.offer || {}),
        offerLines: (this?.offer?.offerLines || [])
          .map((offerLineId) => {
            if (typeof offerLineId === 'string') {
              const offerLine = this.$store.state.entities.offerLines.byId[offerLineId];

              return {
                ...offerLine,
              };
            }

            return offerLineId;
          })
          .filter((o) => o),
      };
    },
  },
};
</script>
